@if (emily.buttonVisible()) {
  <p-button [rounded]="true" class="emily-btn" [class.show]="true"
            (click)="emily.open()">{{ 'app:ask-emily'|translate }}
  </p-button>
}
